import { createSelector } from 'reselect';
import { MESSAGEDETAIL_TYPES, REQUEST_STATUS } from 'src/constants/constants';

import moment from 'moment';

const messagingState = state => state.messaging;
const utilsState = state => state.utils;
const loginState = state => state.login;
const messageBox = (state, boxType) => boxType;
const filterBox = (state, boxType) => boxType;

export const getMessagingState = createSelector(
  [messagingState],
  messaging => messaging,
);

export const getMessages = createSelector(
  [getMessagingState],
  data => {
    if (data.casesMessages) return data.caseMessages;
    return data[data.selectedMenu].messages;
  },
);

export const getUnreadMessages = createSelector(
  [getMessagingState],
  data => {
    let res = [];
    if (data[data.selectedMenu].messages.length) {
      data[data.selectedMenu].messages.forEach(each => {
        if (!each.read) res.push(each);
      });
    }
    return res;
  },
);

export const getFilters = createSelector(
  [getMessagingState],
  data => {
    return data[data.selectedMenu].filters;
  },
);

export const getFirstMessage = createSelector(
  [messagingState, messageBox],
  (data, boxType) => {
    return data[boxType].messages.length ? data[boxType].messages[0] : null;
  },
);

export const getMeta = createSelector(
  [getMessagingState],
  data => {
    return data[data.selectedMenu].meta;
  },
);

export const getFiltersByMailBox = createSelector(
  [getMessagingState, filterBox],
  (data, filterBox) => {
    const val = data[filterBox].filters;
    return val;
  },
);

export const getFirstMailDate = createSelector(
  [getMessagingState, messageBox],
  (data, messageBox) => {
    const messages = data[messageBox].messages;
    const { sortDirection } = data[messageBox].filters;
    //const firstDate = sortDirection === 'desc' ? messages[0].date : messages[messages.length - 1].date;
    const timeOffset = sortDirection === 'desc' ? 2 : -2;

    return messages.length
      ? moment(messages[0].date)
          .add(timeOffset, 'seconds')
          .format('YYYY-MM-DD[T]HH:mm:ss')
      : ''; // string literal '' b/c this is a query param being sent
  },
);

export const getLastMailDate = createSelector(
  [getMessagingState, messageBox],
  (data, messageBox) => {
    const messages = data[messageBox].messages;
    const { sortDirection } = data[messageBox].filters;
    const timeOffset = sortDirection === 'desc' ? -2 : 2;
    //const lastDate = sortDirection === 'desc' ? messages[messages.length - 1].date : messages[0].date;

    return messages.length
      ? moment
          .utc(messages[messages.length - 1].date)
          .add(timeOffset, 'seconds')
          .format('YYYY-MM-DD[T]HH:mm:ss')
      : ''; // string literal '' b/c this is a query param being sent
  },
);

export const checkIsComposeView = createSelector(
  [getMessagingState],
  data => {
    const composeViews = [
      MESSAGEDETAIL_TYPES.COMPOSE,
      MESSAGEDETAIL_TYPES.DRAFT,
      MESSAGEDETAIL_TYPES.REPLY,
      MESSAGEDETAIL_TYPES.REPLY_TO_ALL,
      MESSAGEDETAIL_TYPES.FORWARD,
    ];
    const isComposeView = composeViews.includes(data.detailType);
    return isComposeView ? true : false;
  },
);

export const checkIsReplyView = createSelector(
  [getMessagingState],
  data => {
    const replyViews = [MESSAGEDETAIL_TYPES.REPLY, MESSAGEDETAIL_TYPES.REPLY_TO_ALL];
    const isIsReplyView = replyViews.includes(data.detailType);
    return isIsReplyView ? true : false;
  },
);

export const checkIsForwardView = createSelector(
  [getMessagingState],
  data => {
    return data.detailType === MESSAGEDETAIL_TYPES.FORWARD ? true : false;
  },
);

export const checkIsDraftView = createSelector(
  [getMessagingState],
  data => {
    return data.countDrafts > 0 && data.detailType === MESSAGEDETAIL_TYPES.DRAFT ? true : false;
  },
);

export const getLoginInfo = createSelector(
  [loginState],
  data => data,
);
export const getMessageShown = createSelector(
  [messagingState],
  data => data.messageShown,
);

export const isRequestLoading = requestIds =>
  createSelector(
    [utilsState],
    data => {
      let isLoading = false;
      requestIds.forEach(requestId => {
        let reqValue = data.requests[requestId].requestStatus;
        if (reqValue === REQUEST_STATUS.PENDING) isLoading = true;
      });
      //if any requests are not pending, return false
      return isLoading;
    },
  );
